import { COMMON_STATUS_LABEL } from "@/lib/i18nLabels";
// R1.1 (2026-08-27) — WO stage grouping + action bucket helpers.
// SINGLE SOURCE OF TRUTH — dipakai oleh WOMasterDetailView untuk count, filter,
// dan tabel. Diekstrak ke lib supaya bisa di-unit-test tanpa mount komponen
// (yang butuh react-router-dom / DOM). Jangan duplikasi mapping di tempat lain.

export const STAGE_GROUPS = {
  wo_diterima:   ["wo_diterima"],
  site_survey:   ["site_survey"],
  // 149-cw-r94 (2026-08-27): SPH/Negosiasi vs Penerbitan PO dipisah.
  // Legacy keys (sph_negosiasi_po, menunggu_po) tetap termasuk supaya data
  // lama tetap tereksepsi ke chevron sph_negosiasi.
  sph_negosiasi: ["sph_negosiasi", "sph_negosiasi_po", "menunggu_po"],
  penerbitan_po: ["penerbitan_po"],
  sph_po:        ["sph_negosiasi", "penerbitan_po", "sph_negosiasi_po", "menunggu_po"], // backward-compat group
  pengerjaan:    ["pengerjaan"],
  selesai_fisik: ["selesai_fisik"],
  pembuatan_invoice: ["pembuatan_invoice"],
  invoice:       ["invoice_full", "invoice_95", "invoice_5_retention"],
};

// Match predicate — pusat semua stage/status filtering. `filter` boleh:
//   - "all"                       → no-op
//   - "closed"                    → status===completed
//   - "cancelled_owner"           → status===cancelled_by_owner
//   - group key (STAGE_GROUPS)    → __stage in group list (aktif only)
//   - exact WO_STAGES key         → __stage === filter (aktif only)
export function stageMatches(p, filter) {
  if (!filter || filter === "all") return true;
  if (filter === "closed") return p.status === "completed";
  if (filter === "cancelled_owner") return p.status === "cancelled_by_owner";
  if (p.status === "completed" || p.status === "cancelled_by_owner") return false;
  const group = STAGE_GROUPS[filter];
  if (group) return group.includes(p.__stage);
  return p.__stage === filter;
}

// Dropdown option list (matches PROMPT 16-WO-MONITORING-FUNNEL-R1.1 §C).
export const STAGE_FILTER_OPTIONS = [
  { value: "wo_diterima",         label: "WO Diterima" },
  { value: "site_survey",         label: "Site Survey" },
  { value: "sph_negosiasi",       label: "SPH & Negosiasi" },
  { value: "penerbitan_po",       label: "Penerbitan PO" },
  { value: "pengerjaan",          label: "Pengerjaan" },
  { value: "selesai_fisik",       label: "Selesai Fisik" },
  { value: "pembuatan_invoice",   label: "Pembuatan Invoice" },
  { value: "invoice",             label: "Semua Tahap Pengiriman Invoice" },
  { value: "invoice_full",        label: "Pengiriman Invoice 100%" },
  { value: "invoice_95",          label: "Pengiriman Invoice 95%" },
  { value: "invoice_5_retention", label: "Invoice 5% (Retensi)" },
  { value: "closed",              label: "Closed" },
  { value: "cancelled_owner",     label: "Dibatalkan Owner" },
];

// Perlu Tindakan bucket taxonomy (9 buckets) — click filter menggunakan
// predicate identik dgn count (deriveActionBucket).
export const ACTION_BUCKETS = [
  { key: "belum_survey",           label: "Belum Survey",                    tone: "slate" },
  { key: "belum_sph",              label: "Belum SPH",                       tone: "slate" },
  { key: "menunggu_po",            label: "Menunggu PO",                     tone: "amber" },
  { key: "overdue",                label: COMMON_STATUS_LABEL.overdue,            tone: "rose" },
  { key: "cancelled_owner",        label: "Dibatalkan Owner",                tone: "slate" },
  { key: "selesai_belum_invoice",  label: "Selesai Fisik — Belum Invoice",   tone: "slate" },
  { key: "po_belum_mulai",         label: "PO Belum Mulai",                  tone: "slate" },
  { key: "pengerjaan",             label: "Pengerjaan",                      tone: "orange" },
  { key: "retensi_belum",          label: "Retensi 5% Belum",                tone: "slate" },
];
export const ACTION_BUCKET_META = Object.fromEntries(ACTION_BUCKETS.map((b) => [b.key, b]));

export function deriveActionBucket(p) {
  if (p.status === "cancelled_by_owner") return "cancelled_owner";
  if (p.status === "completed") return "closed";
  // Stage-specific bucket priority tinggi (retensi & selesai fisik) — invoice
  // sudah dianggap "post-action" (menunggu pembayaran, bukan Perlu Tindakan).
  if (p.__stage === "invoice_5_retention") return "retensi_belum";
  if (p.__stage === "selesai_fisik") return "selesai_belum_invoice";
  // Overdue = kondisi urgensi, dipakai untuk stage pre-invoice yang tenggat lewat.
  if (p.__risk?.key === "critical") return "overdue";
  switch (p.__stage) {
    case "wo_diterima":         return "belum_survey";
    case "site_survey":         return "belum_sph";
    // 149-cw-r94: SPH/Negosiasi vs Penerbitan PO dipisah.
    case "sph_negosiasi":       return "menunggu_po";
    case "penerbitan_po":       return "menunggu_po";
    case "sph_negosiasi_po":    return "menunggu_po";
    case "menunggu_po":         return "po_belum_mulai";
    case "pengerjaan":          return "pengerjaan";
    case "pembuatan_invoice":   return "menunggu_invoice";
    // invoice_full / invoice_95 → menunggu pembayaran; TIDAK masuk bucket
    // Perlu Tindakan (mockup R32F hanya punya 9 bucket, no "waiting payment").
    case "invoice_full":
    case "invoice_95":          return null;
    default: return "belum_survey";
  }
}
